import { Typography } from "@suraasa/placebo-ui"

import { StatBox } from "./StatBox"

interface WelcomeViewProps {
  userFirstName?: string
  assessmentName: string
  cpatQuestions: number
  cpatDurationInMinutes: number
}

export const WelcomeView = ({
  userFirstName,
  assessmentName,
  cpatQuestions,
  cpatDurationInMinutes,
}: WelcomeViewProps) => {
  return (
    <>
      <Typography variant="title4" className="mb-2 text-onSurface-500">
        Hi {userFirstName},
      </Typography>

      <div className="mb-4 md:mb-8">
        <Typography variant="title2" className="text-primary-800">
          Welcome to
        </Typography>
        <Typography variant="title2" className="mt-1 text-primary-600">
          {assessmentName}
        </Typography>
      </div>

      <div className="mb-4 h-px w-20 bg-onSurface-200 md:mb-8"></div>

      <div className="grid grid-cols-2 gap-8 lg:grid-cols-3">
        <StatBox
          label="Question count"
          value={
            <>
              {cpatQuestions}{" "}
              <span className="text-base font-normal">Questions</span>
            </>
          }
        />
        <StatBox
          label="Test Duration"
          value={
            <>
              {cpatDurationInMinutes}{" "}
              <span className="text-base font-normal">Minutes</span>
            </>
          }
        />
      </div>
    </>
  )
}
